import { createPrismic } from '@prismicio/vue';

const prismic = createPrismic({
   endpoint: process.env.VUE_APP_PRISMIC_API_ENDPOINT 
});

export default prismic;